import { FC } from 'react';
import { useHistory } from 'react-router';
import { RadabankOnboardingContent } from 'components/RadabankCard';
import { ArrowBackButton, CustomButton } from 'components/shared';
import { FIREBASE_EVENT_ANALYTICS_BUTTON, FIREBASE_EVENT_ANALYTICS_PAGE } from 'utils/constants';
import { ROUTER_URL } from 'utils/enums';
import { useGoBack } from 'utils/hooks';
import { FirebaseAnalytics } from 'utils/services';

export const RadabankOperationBannerPage: FC = () => {
	const history = useHistory();
	const handleClickBack = useGoBack();

	const handleLogAnalyticsMessage = () => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.RADABANK.OPERATION_BANNER,
			FIREBASE_EVENT_ANALYTICS_BUTTON.GO_BACK
		);
	};

	const handleClickButton = () => {
		handleLogAnalyticsMessage();
		history.push(ROUTER_URL.RADABANK_CARD);
	};

	const handleGoBack = () => {
		handleLogAnalyticsMessage();
		handleClickBack();
	};

	return (
		<div className="host-card-page-color-primary">
			<ArrowBackButton onClick={handleGoBack} />
			<RadabankOnboardingContent
				title="Заявку відправлено!"
				description={['Найближчим часом переказ буде здійснено']}
			/>
			<CustomButton label="На головну" color="secondary" onClick={handleClickButton} />
		</div>
	);
};
